import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { Message } from '../../store'

@customElement('chat-messages')
export class ChatMessages extends LitElement {
    @property({ type: Array }) messages: Message[] = []

    static styles = css`
        :host {
            display: block;
            overflow-y: auto;
            padding: var(--s1, 1rem);
        }
        /* Container for the messages with flex and gap for spacing */
        .messages-container {
            display: flex;
            flex-direction: column;
            gap: var(--s1, 1rem);
        }
        /* Base message styling */
        .message {
            padding: var(--s0, 1rem);
            font-size: var(--s1, 1rem);
            font-family: var(--base-font-family);
            line-height: var(--base-line-height, 1.5);
            max-width: 80%;
            word-wrap: break-word;
            margin-bottom: var(--s1, 1rem);
        }
        /* Left (incoming) messages */
        .message-left {
            align-self: flex-start;
            background-color: var(--bg-secondary);
            color: var(--text-primary);
            border-radius: 8px 8px 8px 0;
            animation: slide-in-left 0.3s ease-out forwards;
        }
        /* Right (user) messages */
        .message-right {
            align-self: flex-end;
            background: var(--color-accent);
            color: #fff;
            border-radius: 8px 8px 0 8px;
            animation: slide-in-right 0.3s ease-out forwards;
        }
        @keyframes slide-in-left {
            from {
                opacity: 0;
                transform: translateX(-20px);
            }
            to {
                opacity: 1;
                transform: translateX(0);
            }
        }
        @keyframes slide-in-right {
            from {
                opacity: 0;
                transform: translateX(20px);
            }
            to {
                opacity: 1;
                transform: translateX(0);
            }
        }
    `

    updated(changedProperties: Map<string, any>) {
        // If messages have changed, wait for the update to complete,
        // then use requestAnimationFrame to ensure the layout is rendered.
        if (changedProperties.has('messages')) {
            this.updateComplete.then(() => {
                requestAnimationFrame(() => {
                    this._scrollToBottom()
                })
            })
        }
    }

    private _scrollToBottom() {
        if (this.shadowRoot) {
            this.scrollTop = this.scrollHeight
        }
    }

    render() {
        return html`
            <div class="messages-container">
                ${this.messages.map(
                    msg => html`
                        <div
                            class="message ${msg.sender === 'user'
                                ? 'message-right'
                                : 'message-left'}"
                        >
                            ${msg.text}
                        </div>
                    `,
                )}
            </div>
        `
    }
}
